'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { setupI18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import type { Messages } from '@lingui/core';
import type { ReactNode } from 'react';
interface LinguiClientProviderProps {
  children: ReactNode;
  initialLocale: string;
  initialMessages: Messages;
}

/**
 * Client-side Lingui provider for hydrating i18n state.
 * Use this in client components that need access to translations.
 *
 * @example
 * ```tsx
 * <LinguiClientProvider
 *   initialLocale={locale}
 *   initialMessages={messages[locale]}
 * >
 *   {children}
 * </LinguiClientProvider>
 * ```
 */
export function LinguiClientProvider(t0) {
  const $ = _c(6);
  const {
    children,
    initialLocale,
    initialMessages
  } = t0;
  let t1;
  if ($[0] !== initialLocale || $[1] !== initialMessages) {
    t1 = setupI18n({
      locale: initialLocale,
      messages: {
        [initialLocale]: initialMessages
      }
    });
    $[0] = initialLocale;
    $[1] = initialMessages;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const i18n = t1;
  let t2;
  if ($[3] !== children || $[4] !== i18n) {
    t2 = <I18nProvider i18n={i18n}>{children}</I18nProvider>;
    $[3] = children;
    $[4] = i18n;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}